import React from 'react';
import { Stats } from '@alvogen/shared/components/stats/Stats';

export const Component = () => {
  return (
    <Stats kicker="Stats">
      <Stats.Item label="MAB’s in pipeline">8</Stats.Item>
      <Stats.Item label="Commercial partnerships">20</Stats.Item>
      <Stats.Item label="Development and manufacturing facilities">4</Stats.Item>
    </Stats>
  );
};
